var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19203 9.40468V0.833252H12.0492V9.40468H20.6206V12.2618H12.0492V20.8333H9.19203V12.2618H0.620605V9.40468H9.19203Z",
    fill: "#082026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDark);
export default __webpack_public_path__ + "static/media/addDark.c296eb4a8741a97904651eefb6aa1d18.svg";
export { ForwardRef as ReactComponent };